import { render, staticRenderFns } from "./ResortPointAdd.vue?vue&type=template&id=7b1128da&scoped=true&"
import script from "./ResortPointAdd.vue?vue&type=script&lang=js&"
export * from "./ResortPointAdd.vue?vue&type=script&lang=js&"
import style0 from "./ResortPointAdd.vue?vue&type=style&index=0&id=7b1128da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1128da",
  null
  
)

export default component.exports